// extracted by mini-css-extract-plugin
export default {"container":"Qk-z","blurb":"Rk-z","links":"Sk-z"};